import { t } from "@/lib/i18n";
import { X } from "lucide-react";
import { ClaraAvatar } from "./Brand";
import { AiAssistant } from "./AiAssistant";
import { stopAllAudio } from "./ListenButton";

export const ChatBubble = ({ chat, guideActive, open, setOpen, geo, draft, setDraft, onFollowUp }) => (
  <>
    <div
      data-testid="chat-bubble-panel"
      inert={!open}
      aria-hidden={!open}
      className={`fixed inset-0 z-40 transition-[opacity,transform] duration-300 sm:inset-auto sm:bottom-24 sm:right-6 sm:h-[min(680px,calc(100vh-130px))] sm:w-[420px] ${
        open ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-6 opacity-0"
      }`}
    >
      <AiAssistant chat={chat} geo={geo} open={open} noAutoFocus={guideActive} draft={draft} setDraft={setDraft} onClose={() => { stopAllAudio(); setOpen(false); }} onFollowUp={onFollowUp} />
    </div>
    <button
      data-testid="chat-bubble-button"
      onClick={() => setOpen(!open)}
      aria-label={t("bubble.open")}
      className={`group fixed bottom-5 right-5 z-40 flex items-center gap-3 sm:bottom-6 sm:right-6 ${open || guideActive ? "max-sm:hidden" : ""}`}
    >
      {!open && (
        <span className="hg-rise hidden rounded-2xl rounded-br-sm bg-ac-surface px-4 py-2.5 text-sm font-medium text-ac-ink shadow-xl sm:block">
          {t("bubble.hint")}
        </span>
      )}
      <span className="relative grid h-16 w-16 place-items-center rounded-full bg-ac-primary text-white shadow-[0_12px_30px_-6px_rgba(28,126,214,0.75)] transition-transform group-hover:scale-105 group-active:scale-95">
        {!open && <span className="absolute inset-0 animate-ping rounded-full bg-ac-primary-glow" />}
        {open ? <X className="relative h-7 w-7" /> : <ClaraAvatar size="h-[60px] w-[60px]" online={false} />}
        {!open && <span className="absolute -right-0.5 -top-0.5 h-4 w-4 rounded-full border-2 border-white bg-ac-accent" />}
      </span>
    </button>
  </>
);
